export const statusList = [
  {
    value: 'DRAFT',
    text: 'Черновик'
  },
  {
    value: 'ON_MODERATION',
    text: 'На модерации'
  },
  {
    value: 'PUBLISHED',
    text: 'Опубликовано'
  },
  {
    value: 'HIDDEN',
    text: 'Скрыто'
  }
]

export const statusesAccess = [
  {
    value: 'GRANTED',
    text: 'Предоставлен'
  },
  {
    value: 'PENDING',
    text: 'Предоставить'
  }
]
